import {
  FieldDef,
  formatAmount,
  formatDate,
  formatDateTime,
  formatDollarAmount,
} from "@synota-io/synota-shared-ui";
import { IInvoice } from "../../../../api/hooks/useInvoices";

export const invoiceFields: FieldDef<IInvoice>[] = [
  {
    field: "shared_uuid",
    headerName: "ID",
    minWidth: 120,
    displayTags: [],
    type: "number",
  },
  {
    field: "invoice_number",
    headerName: "Invoice Number",
    minWidth: 120,
    align: "right",
    headerAlign: "right",
  },
  {
    field: "energy_date",
    headerName: "Energy Date",
    minWidth: 120,
    type: "number",
    displayTags: ["summary", "table"],
    valueFormatter: (value) => formatDate(value),
  },
  {
    field: "invoice_datetime",
    headerName: "Invoice Date (UTC)",
    minWidth: 170,
    type: "number",
    valueFormatter: (value) => formatDateTime(value),
  },
  {
    field: "effective_rate",
    headerName: "Effective Rate",
    minWidth: 190,
    type: "number",
    displayTags: ["summary", "table"],
    valueFormatter: (value) => formatDollarAmount(value),
  },
  {
    field: "units_consumed",
    headerName: "Units Consumed",
    minWidth: 190,
    type: "number",
    displayTags: ["summary", "table"],
    valueFormatter: (value, row) => `${formatAmount(value, 2)} ${row.unit_of_measure}`,
  },
  {
    field: "invoice_amount",
    headerName: "Amount",
    minWidth: 190,
    type: "number",
    displayTags: ["summary", "table"],
    valueFormatter: (value) => formatDollarAmount(value),
  },
  {
    field: "amount_paid",
    headerName: "Amount Paid",
    minWidth: 120,
    type: "number",
    valueFormatter: (value) => formatDollarAmount(value),
  },
  {
    field: "amount_pending",
    headerName: "Amount Pending",
    minWidth: 190,
    type: "number",
    valueFormatter: (value) => formatDollarAmount(value),
  },
  {
    field: "outstanding_amount",
    headerName: "Amount Outstanding",
    minWidth: 190,
    type: "number",
    valueFormatter: (value) => formatDollarAmount(value),
  },
];
